/**
 * FAQ deep links
 */
(() => {
  const ANCHOR_ATTR = 'data-faq-anchor';

  const escapeValue = (value) =>
    window.CSS && CSS.escape ? CSS.escape(value) : value.replace(/["\\]/g, '\\$&');

  const resolveTarget = (hash) => {
    if (!hash || hash.length < 2) return null;

    const raw = hash.slice(1);
    let id = raw;
    try {
      id = decodeURIComponent(raw);
    } catch (error) {
      id = raw;
    }

    return document.querySelector(`[${ANCHOR_ATTR}="${escapeValue(id)}"]`) || document.getElementById(id);
  };

  const collectDetails = (target) => {
    const list = [];
    const own = target.matches('details') ? target : target.querySelector('details');
    if (own) list.push(own);

    let node = target.parentElement;
    while (node) {
      const ancestor = node.closest('details');
      if (!ancestor) break;
      list.push(ancestor);
      node = ancestor.parentElement;
    }

    return list.reverse();
  };

  const openTarget = (target) => {
    collectDetails(target).forEach((details) => {
      if (details.open) return;
      try {
        details.open = true;
      } catch (error) {
        details.setAttribute('open', '');
      }
      if (!details.hasAttribute('open')) details.setAttribute('open', '');
    });

    const summary = target.querySelector('summary');
    if (summary) summary.focus({ preventScroll: true });
  };

  const activate = (hash) => {
    const target = resolveTarget(hash);
    if (!target) return null;

    openTarget(target);
    return target;
  };

  const replaceHash = (hash) => {
    if (!window.history.replaceState) return;
    window.history.replaceState(null, '', window.location.pathname + window.location.search + hash);
  };

  const onSummaryClick = (event) => {
    if (!event.target.closest) return;

    const summary = event.target.closest('summary');
    if (!summary) return;

    const item = summary.closest(`[${ANCHOR_ATTR}]`);
    if (!item) return;

    const details = item.matches('details') ? item : item.querySelector('details');
    if (!details) return;

    window.setTimeout(() => {
      if (!details.open) return;
      const hash = '#' + item.getAttribute(ANCHOR_ATTR);
      if (window.location.hash !== hash) replaceHash(hash);
    }, 0);
  };

  const onSameHashClick = (event) => {
    const link = event.target.closest && event.target.closest('a[href*="#"]');
    if (!link) return;

    const url = new URL(link.href, window.location.href);
    if (url.pathname !== window.location.pathname || url.search !== window.location.search) return;
    if (!url.hash || url.hash === '#' || url.hash !== window.location.hash) return;

    const target = activate(url.hash);
    if (!target) return;

    event.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const init = () => {
    if (window.location.hash) activate(window.location.hash);
  };

  document.addEventListener('click', onSummaryClick);
  document.addEventListener('click', onSameHashClick);
  window.addEventListener('hashchange', () => activate(window.location.hash));
  document.addEventListener('shopify:section:load', init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
